import Vue from 'vue'
import Router from 'vue-router'
import SelectBC from '@/views/purchase/SelectBC'
import SelectProducts from '@/views/purchase/SelectProducts'
import PurchaseDiscount from '@/views/purchase/Discount'
import DetailInformation from '@/views/purchase/DetailInformation'
import Confirm from '@/views/purchase/Confirm'
import PurchaseComplete from '@/views/purchase/Complete'

import SubSelectBC from '@/views/subscription/SubSelectBC'
import SubSelectProducts from '@/views/subscription/SubSelectProducts'
import SubSelectProductsList from '@/views/subscription/SubSelectProductsList'
import SubDetailInformation from '@/views/subscription/SubDetailInformation'
import ShippingPlan from '@/views/subscription/ShippingPlan'
import SubConfirm from '@/views/subscription/SubConfirm'
import RepeatComplete from '@/views/subscription/Complete'

import MultiBcSubSelectProducts from '@/views/subscriptionMultiBc/SubSelectProducts'
import MultiBcSubSelectProductsList from '@/views/subscriptionMultiBc/SubSelectProductsList'
import MultiBcShippingPlan from '@/views/subscriptionMultiBc/ShippingPlan'
import MultiBcSubConfirm from '@/views/subscriptionMultiBc/SubConfirm'
import MultiBcRepeatComplete from '@/views/subscriptionMultiBc/Complete'

// import Calendar from '@/views/viewCalendar'
import SalonSchedule from '@/views/salon/Schedule'
import SalonScheduleDetail from '@/views/salon/ScheduleDetail'

import MemberLimitDate from '@/views/member/LimitDate'
import AddCreditCard from '@/views/member/AddCreditCard'
import AddAddress from '@/views/member/AddAddress'
import EditBankAccount from '@/views/member/EditBankAccount'
import MemberBankAccountUse from '@/views/member/bankAccount/Use.vue'
import MemberBankAccountUseWeb from '@/views/member/bankAccount/UseWeb.vue'
import MemberBankAccountUsePaper from '@/views/member/bankAccount/UsePaper.vue'

import Information from '@/views/notification/Information'
import SummitMemberList from '@/views/fanClub/summitMember/SummitMemberList'
import SummitMember from '@/views/fanClub/summitMember/SummitMember'

import Leaders from './leaders'

import FanClubApply from '@/views/fanClub/register/Apply'
import FanClubRegister from '@/views/fanClub/register/Terms'
import FanClubRegisterSelectPlan from '@/views/fanClub/register/SelectPlan'
import FanClubRegisterConfirm from '@/views/fanClub/register/Confirm'
import FanClubRegisterComplete from '@/views/fanClub/register/Complete'

import FellowTimesArchive from '@/views/fanClub/fellowTimes/PostList'
import FellowTimesSingle from '@/views/fanClub/fellowTimes/PostDetail'

import HealthTopicArchive from '@/views/fanClub/healthTopic/PostList'
import HealthTopicSingle from '@/views/fanClub/healthTopic/PostDetail'

import ColumnList from '@/views/fanClub/column/ColumnList'
import ColumnSingle from '@/views/fanClub/column/ColumnDetail'

import Notes from '@/views/fanClub/notes/Notes'
import NotesDoNotGiveUp from '@/views/fanClub/notes/NotesDoNotGiveUp'

import Campaign from '@/views/campaign/campaign'
import CampaignNewRegistration from '@/views/campaign/NewRegistration'
import CampaignCheck from "./campaign"

import WalletSalesSummaryReport from '@/views/wallet/salesSummaryReport/SalesSummaryReport'
import WalletAccessDetail from '@/views/wallet/salesSummaryReport/AccessDetail'
import WalletNdsDetail from '@/views/wallet/salesSummaryReport/NdsDetail'

import WalletCashFlow from '@/views/wallet/cashFlow/CashFlow'
import WalletWithdrawBankCheck from '@/views/wallet/withdraw/WithdrawBankCheck'
import WalletWithdraw from '@/views/wallet/withdraw/Withdraw'
import WalletWithdrawConfirm from '@/views/wallet/withdraw/WithdrawConfirm'
import WalletWithdrawComplete from '@/views/wallet/withdraw/WithdrawComplete'

import NSelection from './n-selection'
import Cancellation from '@/views/member/contract/Cancellation'
import InvoiceNumber from '@/views/member/invoice/InvoiceNumber';

import Salon from '@/views/salon/Salon'
import Reservation from '@/views/salon/Reservation'
import ReservationSeminar from '@/views/salon/ReservationSeminar'
import ReservationConfirm from '@/views/salon/ReservationConfirm'
import AvailabilityStatus from '@/views/salon/AvailabilityStatus'
import ReservationList from '@/views/salon/ReservationList'
import OmikujiTest from './omikujiTest'
import Keepgoing from './keepgoing'
import TestCode from '@/views/TestCode'
import WelcomeCall from './welcomeCall'
import inquiryRoutes from './inquiry'

Vue.use(Router)

const routes = [
  {
    path: '/test_code',
    name: 'testCode',
    component: TestCode
  },

  {
    path: '/purchase/selectBC',
    name: 'selectBC',
    component: SelectBC
  },
  {
    path: '/purchase/selectProducts',
    name: 'SelectProducts',
    component: SelectProducts,
  },
  {
    path: '/purchase/discount',
    name: 'PurchaseDiscount',
    component: PurchaseDiscount,
  },
  {
    path: '/purchase/selectPaymentAndShipping',
    // name: 'DetailInformation',
    name: 'purchaseSelectPaymentAndShipping',
    component: DetailInformation
  },

  {
    path: '/purchase/confirm',
    name: 'Confirm',
    component: Confirm,
    props: true
  },
  {
    path: '/purchase/complete',
    name: 'purchaseComplete',
    component: PurchaseComplete,
    props: true
  },

  {
    path: '/repeatOrder/selectBC',
    name: 'subSelectBC',
    component: SubSelectBC,
  },
  {
    path: '/repeatOrder/selectProducts',
    name: 'subSelectProducts',
    component: SubSelectProducts,
    props: true
  },
  {
    path: '/repeatOrder/selectProductsDetail',
    name: 'subSelectProductsList',
    component: SubSelectProductsList
  },
  {
    path: '/repeatOrder/selectPaymentAndShipping',
    name: 'repeatSelectPaymentAndShipping',
    component: SubDetailInformation
  },
  {
    path: '/repeatOrder/shippingPlan',
    name: 'shippingPlan',
    component: ShippingPlan
  },
  {
    path: '/repeatOrder/confirm',
    name: 'subConfirm',
    component: SubConfirm,
    props: true
  },
  {
    path: '/repeatOrder/complete',
    name: 'repeatComplete',
    component: RepeatComplete,
    props: true
  },
  {
    path: '/repeatOrder/multiBc/selectProducts',
    name: 'multiSubSelectProducts',
    component: MultiBcSubSelectProducts,
    props: true
  },
  {
    path: '/repeatOrder/multiBc/selectProductsDetail',
    name: 'multiSubSelectProductsList',
    component: MultiBcSubSelectProductsList
  },
  {
    path: '/repeatOrder/multiBc/shippingPlan',
    name: 'multiShippingPlan',
    component: MultiBcShippingPlan
  },
  {
    path: '/repeatOrder/multiBc/confirm',
    name: 'multiSubConfirm',
    component: MultiBcSubConfirm,
    props: true
  },
  {
    path: '/repeatOrder/multiBc/complete',
    name: 'multiRepeatComplete',
    component: MultiBcRepeatComplete,
    props: true
  },
  {
    path: '/schedule',
    name: 'salonSchedule',
    component: SalonSchedule,
  },
  {
    path: '/schedule/detail',
    name: 'salonScheduleDetail',
    component: SalonScheduleDetail,
  },
  {
    path: '/member/limitDate',
    name: 'memberLimitDate',
    component: MemberLimitDate
  },
  {
    path: '/member/addCreditCard',
    name: 'AddCreditCard',
    component: AddCreditCard,
  },
  {
    path: '/member/addDeliveryAddress',
    name: 'addAddress',
    component: AddAddress
  },
  {
    path: '/member/editBankAccount',
    name: 'editBankAccount',
    component: EditBankAccount
  },
  {
    path: '/member/bankAccount/use',
    name: 'MemberBankAccountUse',
    component: MemberBankAccountUse
  },
  {
    path: '/member/bankAccount/use/web',
    name: 'MemberBankAccountUseWeb',
    component: MemberBankAccountUseWeb
  },
  {
    // 以前は完了案内ページに遷移していたが不要のため削除
    path: '/member/bankAccount/use/web/complete',
    name: 'MemberBankAccountUseWebComplete',
    component: { render: h => h() }
  },
  {
    path: '/member/bankAccount/use/paper',
    name: 'MemberBankAccountUsePaper',
    component: MemberBankAccountUsePaper
  },
  {
    path: '/member/cancellation',
    name: 'Cancellation',
    component: Cancellation
  },
  {
    path: '/member/invoiceNumber',
    name: 'InvoiceNumber',
    component: InvoiceNumber
  },
  {
    path: '/notification/information',
    name: 'notificationInformation',
    component: Information
  },
  {
    path: '/fanClub/summitMemberList',
    name: 'fanClubSummitMemberList',
    component: SummitMemberList
  },
  {
    path: '/fanClub/summitMember',
    name: 'fanClubSummitMember',
    component: SummitMember
  },

  {
    path: '/fanClub/register',
    name: 'fanClubRegister',
    component: FanClubApply
  },
  {
    path: '/fanClub/terms',
    name: 'fanClubTerms',
    component: FanClubRegister
  },
  {
    path: '/fanClub/selectPlan',
    name: 'fanClubRegisterSelectPlan',
    component: FanClubRegisterSelectPlan
  },
  {
    path: '/fanClub/confirm',
    name: 'fanClubRegisterConfirm',
    component: FanClubRegisterConfirm
  },

  {
    path: '/fanClub/complete',
    name: 'fanClubRegisterComplete',
    component: FanClubRegisterComplete
  },
  {
    path: '/fanClub/fellowTimesList',
    name: 'fellowTimesArchive',
    component: FellowTimesArchive,
    props: true
  },
  {
    path: '/fanClub/fellowTimesList/:id',
    name: 'fellowTimesSingle',
    component: FellowTimesSingle,
  },
  {
    path: '/fanClub/healthTopicList',
    name: 'healthTopicArchive',
    component: HealthTopicArchive,
    props: true
  },
  {
    path: '/fanClub/healthTopicList/:id',
    name: 'healthTopicSingle',
    component: HealthTopicSingle
  },


  {
    path: '/wallet/salesSummaryReport',
    name: 'WalletSalesSummaryReport',
    component: WalletSalesSummaryReport
  },
  {
    path: '/wallet/salesSummaryReport/accessDetail',
    name: 'WalletAccessDetail',
    component: WalletAccessDetail
  },
  {
    path: '/wallet/salesSummaryReport/ndsDetail',
    name: 'WalletNdsDetail',
    component: WalletNdsDetail
  },

  {
    path: '/wallet/cashFlow',
    name: 'WalletCashFlow',
    component: WalletCashFlow
  },
  {
    path: '/wallet/withdraw',
    name: 'WalletWithdrawBankCheck',
    component: WalletWithdrawBankCheck
  },

  {
    path: '/wallet/withdraw/input',
    name: 'WalletWithdraw',
    component: WalletWithdraw
  },
  {
    path: '/wallet/withdraw/confirm',
    name: 'WalletWithdrawConfirm',
    component: WalletWithdrawConfirm
  },
  {
    path: '/wallet/withdraw/complete',
    name: 'WalletWithdrawComplete',
    component: WalletWithdrawComplete
  },

  {
    path: '/fanClub/articleList',
    name: 'ColumnList',
    component: ColumnList,
  },
  {
    path: '/fanClub/articleList/:articleId',
    name: 'ColumnSingle',
    component: ColumnSingle,
  },
  {
    path: '/fanClub/notes',
    name: 'Notes',
    component: Notes,
  },
  {
    path: '/fanClub/notes/doNotGiveUp',
    name: 'NotesDoNotGiveUp',
    component: NotesDoNotGiveUp,
  },
  {
    path: '/campaign/:id',
    name: 'Campaign',
    component: Campaign
  },
  {
    path: '/campaign/newRegistration',
    name: 'CampaignNewRegistration',
    component: CampaignNewRegistration
  },
  // {
  //   path: '/salon/availabilityStatus',
  //   name: 'AvailabilityStatus',
  //   component: AvailabilityStatus
  // },
  {
    path: '/salon',
    component: Salon,
    children: [
      {
        path: 'reservation',
        name: 'Reservation',
        component: Reservation,
      },
      {
        path: 'reservation/seminar',
        name: 'ReservationSeminar',
        component: ReservationSeminar,
      },
      {
        path: 'reservation/confirm',
        name: 'ReservationConfirm',
        component: ReservationConfirm,
      },
      {
        path: 'availabilityStatus',
        name: 'AvailabilityStatus',
        component: AvailabilityStatus,
      },
      {
        path: 'reservationList',
        name: 'ReservationList',
        component: ReservationList,
      }
    ]
  },
  {
    ...NSelection
  },
  {
    ...Leaders
  },
  {
    ...CampaignCheck
  },
  {
    ...OmikujiTest
  },
  {
    ...Keepgoing
  },
  {
    ...WelcomeCall
  },
  ...inquiryRoutes
]

export default new Router({
  mode: 'history',
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js